import { FunctionComponent } from "react";

import {
  BillingHistory,
  Transaction
} from "rivals/components/pages/User/BillingHistory/types";
import RivalsTable from "rivals/components/shared/Tables/RivalsTable";
import { setData } from "rivals/shared/utils/qa";
import styles from "./BillingHistoryTable.module.scss";
import { columns } from "./columns";
import strings from "./strings";

type Props = BillingHistory;

const BillingHistoryTable: FunctionComponent<Props> = ({ transactions }) => {
  const historyTable = (
    <RivalsTable<Transaction>
      className={styles.tableStyles}
      columns={columns}
      data={transactions || []}
      philter={strings.philter}
      rowKey={strings.rowKey}
      stripedRows
      tableKey={strings.tableKey}
      xScrollLimit={886}
    />
  );

  return (
    <div className={styles.tableContainer} {...setData(strings.philter)}>
      {historyTable}
    </div>
  );
};

export default BillingHistoryTable;
